import React from "react";

/**
 * One language half of a bilingual field group: a quiet bordered block with a
 * heading and a language code.
 *
 * Both language blocks are always rendered side by side or stacked — never
 * behind tabs. Tabs would unmount the rich-text editor of the inactive
 * language, which drops its content and its cursor; the editor workspace is
 * mount-all for exactly that reason (L3).
 *
 * The code pill is deliberately neutral (`border-border`, no colour fill).
 * The light theme force-fills compact `rounded-full` pills that carry the
 * emerald/amber/red utility combinations (`index.css`), and a status colour
 * here would read as a state the language is not in.
 */
export default function ListingLanguageBlock({ title, code, children }) {
  return (
    <section
      aria-label={title}
      className="rounded-xl border border-border bg-muted/20 p-4 sm:p-5"
    >
      <div className="mb-4 flex items-center gap-2">
        <h5 className="m-0 text-[13px] font-semibold text-foreground">{title}</h5>
        <span className="rounded-full border border-border px-2 py-0.5 text-[11px] font-medium text-muted-foreground">
          {code}
        </span>
      </div>
      <div className="grid gap-4">{children}</div>
    </section>
  );
}
